export default "__VITE_ASSET__CiQUC0Js__"